import React, { useContext } from "react";
import { useForm, FormProvider } from 'react-hook-form';
import {bssMakeStyles}  from '../../lib/theming';
import Wrapper from '../Wrapper';
import useBSSLogger from "../../hooks/useBSSLogger";

const {logger} = useBSSLogger();

import { Box, Button, Card, Grid } from '@mui/material';

import __t from "../../lib/traduzioni";
import FrammentoRiepilogo, { nextUrlByStep } from "./frammenti/FrammentoRiepilogo";
import BSSPreventivoContext from "../../contexts/BSSPreventivoContext";
import FrammentoMittDest from "./frammenti/FrammentoMittDest";
import FrammentoMerce from "./frammenti/FrammentoMerce";
import FrammentoSubmitCarrello from "./frammenti/FrammentoSubmitCarrello";
import FrammentoRitiro from "./frammenti/FrammentoRitiro";
import { addDays, format } from "date-fns";
import { useLocalStorage } from "react-use";
import BSSForm from "../form/BSSForm";
import { orderFromCart } from "../../api/testataordine"
import { convertiFormRequestCalcola, DefaultSubmitErrorHandler } from "./Preventivo";

const FormMittDest = ({destRiepilogo = null, destMerce = null, destRitiro = null, destSubmitCarrello = null, step=3, defaultValues, daShortcode, aggiornaPreventivoStorage, nextUrl = null, ...rest}) => {
    
    const contesto = useContext(BSSPreventivoContext);

    const [carrelloStorage = {preventivi: [], pagamenti: {}, datiFatturazione: {}}, aggiornaCarrelloStorage, rimuoviCarrelloStorage] = useLocalStorage("spedizioniweb2_preventivo_carrello");


    const {preventivoStorage = {}} = contesto;

    const props = {destRiepilogo, destMerce, destRitiro, destSubmitCarrello};
    const dests = ["Riepilogo", "Merce", "Ritiro", "SubmitCarrello"];

    const usePortals = dests.reduce((obj, dest) => {
        const selector = props[`dest${dest}`];
        const destel = document.querySelector(`#${selector}`);
        const esito = (selector !== null && destel !== null) ? destel : false;
        logger.finest({dest, selector, destel, esito})
        return {
            ...obj,
            [dest]: esito
        }
    }, {})

    const defMittDest = {        
        id: null,
        ragionesociale: "",
        prefisso: "",
        telefono: "",
        contattare: "",
        email: "",
        indirizzo: "",
        civico: "",
        note: "",
        def: false,
        comune: {
            id: null,
            cap: "",
            comune: "",
            nazione: {
                id: null,
                nazione: "",
                iso: ""
            },
            provincia: {
                id: null,
                provincia: "",
                iso: ""
            }

        }
    }
    

    const indirizzoDefault = (contesto) => {
        const contesti = {"mittente": "partenza", "destinatario": "arrivo"};
        let comune = defaultValues?.[`comune_${contesti[contesto]}`] ?? {};
        let idComune = comune.id ?? null;

        if(idComune === null){
            const capManuale = defaultValues[`comune_cap_${contesti[contesto]}`];
            const comuneManuale = defaultValues[`comune_comune_${contesti[contesto]}`];
            const nazione = defaultValues[`nazione_${contesti[contesto]}`]
            comune = {
                id: null, 
                cap: capManuale, 
                comune: comuneManuale, 
                provincia: {id: null, provincia: null, iso: ""},
                nazione,
            }
        }


        const indirizzo = {
            comune,
            def: false,
        }

        return {...indirizzo}

    }


    defaultValues =  {
        mittente: indirizzoDefault("mittente"),
        destinatario: indirizzoDefault("destinatario"),
        valmerce: 0.00,
        dataritiro: "",
        ...defaultValues,
        colli: (preventivoStorage?.colli ?? []).map(collo => ({...collo, naturamerce: collo?.naturamerce ?? ""})),
    }

    const classes = bssMakeStyles();


    logger.debug("inizializzo il form dello step 3 con i dati default", defaultValues)
    const methods = useForm({
        defaultValues,
        reValidateMode: 'onBlur',        
    });
    const {handleSubmit, formState, control} = methods;
    

    const onSubmit = async (data, contesto) => {
        logger.info("=======> dati form mittente destinatario: ", contesto, data);

        const {preventivi: preventiviACarrello = []} = carrelloStorage


        const carrelloAggiornato = {
            ...carrelloStorage,
            preventivi: [...carrelloStorage.preventivi, data]
        };

        const dati = {
            carrello: {
                preventivi: [
                    ...carrelloAggiornato.preventivi.map(preventivo => convertiFormRequestCalcola(preventivo)),
                ],
            },
        }

        logger.debug("salvo il carrello tramite api", dati)
        const carrello = await orderFromCart(dati)
        logger.debug("carrello salvato sul database", carrello)
        

        aggiornaCarrelloStorage(carrelloAggiornato)

        aggiornaPreventivoStorage({})


        let detail = {
            dati,
            carrelloStorage
        };

        if(contesto === "salvaeaggiungi"){
            detail.operazione = `AGGIUNGI_SPEDIZIONE`
            location.href = nextUrlByStep(1);
        } else {
            detail.operazione = `PAGAMENTO`
            location.href = nextUrlByStep(4);
        }

        const eventoPreventivatore = new CustomEvent("spedizioniweb2_step_3", {
            detail//@todo definire dati da passare all'evento
        });
        document.dispatchEvent(eventoPreventivatore);
        
    
        logger.info("faccio avanzare il preventivo per: ", datiRequest);
        return true

    }

    

    const fragmentDefualtProps = {
        methods,
        classes,
        aggiornaPreventivoStorage,
        onSubmit,
        step
    }

    const submitProps = {
        ...fragmentDefualtProps, 
        onSubmit: handleSubmit(onSubmit, DefaultSubmitErrorHandler) //funzionamento standard
        // onSubmit: contesto => {
        //     logger.debug("effettuo submit con handlesubmit passando il contesto", contesto)
        //     handleSubmit(data => onSubmit(data, contesto), err => onSubmitError(err))
        // }
    }

    const popolaDemo = () => {

        (preventivoStorage?.colli ?? []).forEach((collo, indice) => {
            methods.setValue(`colli.${indice}.naturamerce`, `Natura ${indice+1}`)
        })
        
        methods.setValue("mittente", {
            ...methods.getValues("mittente"),
            id: null,
            ragionesociale: "Mario Rossi",            
            prefisso: "0932",
            numero: "123123123",
            contattare: "Mario",
            email: "m.r@os.si",
            indirizzo: "Via Fasulla",
            civico: "123c",
            note: "citofonare Famiglia Rossi Verdi",
            def: true,                            
        })

        methods.setValue("destinatario", {
            ...methods.getValues("destinatario"),
            id: null,
            ragionesociale: "Luigi Verdi",
            prefisso: "0932",
            numero: "234234234",
            contattare: "Luigi",
            email: "l.v@er.di",
            indirizzo: "Via Inesistente",
            civico: "999c",
            note: "citofonare Famiglia Verdi Gialli",
            def: false,            
        })

        methods.setValue("dataritiro", format(addDays(new Date(), 1), "yyyy-MM-dd"));

        //methods.setValue("valmerce", "123.45")

        
    }

    

    return (
        <>
            <Button style={{display: "none"}} color="primary" variant="contained" onClick={e => popolaDemo()}>Popola con dati fittizi</Button>
            <FormProvider {...methods}>
                <BSSForm onSubmit={handleSubmit(onSubmit, DefaultSubmitErrorHandler)}>                    

                    <Grid container >
                        <>  
                            {(usePortals["Riepilogo"] !== false)?
                                createPortal(
                                    <Wrapper inPortal>
                                        <FrammentoRiepilogo {...fragmentDefualtProps} />                                        
                                    </Wrapper>,                                    
                                    usePortals["Riepilogo"]
                                )
                                : 
                                <Box px={1} mb={3} width={1}>
                                    <Card>
                                        <FrammentoRiepilogo {...fragmentDefualtProps} />
                                    </Card>
                                </Box>

                                
                            }
                        </>                        
                        <>
                            <FrammentoMittDest {...fragmentDefualtProps} />
                        </>


                        <>  
                            {(usePortals["Ritiro"] !== false)?
                                createPortal(
                                    <Wrapper inPortal>
                                        <FrammentoRitiro {...fragmentDefualtProps} />                                        
                                    </Wrapper>,                                    
                                    usePortals["Ritiro"]
                                )
                                : 
                                <FrammentoRitiro {...fragmentDefualtProps} />                                                                        
                                
                            }
                        </> 

                        <>  
                            {(usePortals["Merce"] !== false)?
                                createPortal(
                                    <Wrapper inPortal>
                                        <FrammentoMerce {...fragmentDefualtProps} />                                        
                                    </Wrapper>,                                    
                                    usePortals["Merce"]
                                )
                                : 

                                <FrammentoMerce {...fragmentDefualtProps} />                                                                        
                                
                            }
                        </> 

                        <>  
                            {(usePortals["SubmitCarrello"] !== false)?
                                createPortal(
                                    <Wrapper inPortal>
                                        <FrammentoSubmitCarrello {...submitProps} />                                        
                                    </Wrapper>,                                    
                                    usePortals["SubmitCarrello"]
                                )
                                : 
                                <FrammentoSubmitCarrello {...submitProps} />                                
                            }
                        </>    
                    </Grid>
                </BSSForm>
            </FormProvider>

        </>
    )
}

export default FormMittDest
